import { useEffect, useState } from 'react'
import { Modal } from 'components/core-ui/Modal'
import { DocumentsListForm } from './DocumentsListForm'
import { DocumentForm } from './DocumentForm'

export interface UploadFilesModal {
  isModalOpen: boolean
  closeModal: () => void
  saveDocuments: (documents: any) => void
  documentTypesOptions?: AutocompleteOption[]
  documentType?: AutocompleteOption
  accept?: string
}

export interface UploadDocument {
  id: number
  documentType: AutocompleteOption
  images: File[]
}

const UploadFilesModal = (props: UploadFilesModal) => {
  const { isModalOpen, closeModal, saveDocuments, documentTypesOptions, documentType, accept } =
    props

  const [documents, setDocuments] = useState<UploadDocument[]>([])
  const [selectedDocumentType, setSelectedDocumentType] = useState(null)
  const [step, setStep] = useState(0)

  useEffect(() => {
    if (documentType) {
      setSelectedDocumentType(documentType)
      setStep(1)
    }
  }, [documentType])

  const cancelModal = () => {
    setSelectedDocumentType(null)
    setStep(documentType ? 1 : 0)
    setDocuments([])
    closeModal()
  }

  const saveData = (newDocuments = null) => {
    saveDocuments(newDocuments || documents)
    cancelModal()
  }

  const addDocument = (images: File[]) => {
    const newDocument = {
      id: documents.length + 1,
      documentType: selectedDocumentType,
      images
    }
    const newDocuments = [...documents, newDocument]

    setDocuments(newDocuments)
    setSelectedDocumentType(null)
    setStep(documentType ? 1 : 0)

    if (documentType) {
      saveData(newDocuments)
    }
  }

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={cancelModal}
      modalTitle={
        step === 0
          ? 'Upload documente'
          : `Adauga imagini la ${documentType?.label || selectedDocumentType?.label}`
      }
      modalWidth="40%"
    >
      {step === 0 && (
        <DocumentsListForm
          documents={documents}
          setDocuments={setDocuments}
          selectedDocumentType={selectedDocumentType}
          setSelectedDocumentType={setSelectedDocumentType}
          setStep={setStep}
          cancelModal={cancelModal}
          saveData={saveData}
          documentTypesOptions={documentTypesOptions}
        />
      )}
      {step === 1 && (
        <DocumentForm
          cancelModal={cancelModal}
          addDocument={addDocument}
          accept={accept}
          documentType={documentType}
          saveData={saveData}
        />
      )}
    </Modal>
  )
}

export default UploadFilesModal
